<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="400px" lazy>
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ `${$t("save")} ${$t("calculation").toLowerCase()}`  }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text style="max-height: 320px; overflow-y: auto;">
                    <v-container grid-list-md py-0>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-select
                                    v-model="selectedContract"
                                    :items="contracts"
                                    item-text="Name"
                                    item-value="id"
                                    :label="`${$t('contract')} *`"
                                    required
                                    hide-details
                                    >
                                </v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="name"
                                    :label="`${$t('name')} *`"
                                    required
                                    hide-details
                                    >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="comment"
                                    :label="`${$t('comment')}`"
                                    hide-details
                                    >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-select
                                    v-model="patternsAmount"
                                    :items="amount"
                                    :label="`${$t('savingPatternsAmount')}`"
                                    >
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        @click="saveDataClick"
                        :disabled="!selectedContract || !name"
                    >{{ $t("save") }}</v-btn>
                    <v-btn color="error" @click="cancelClick">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox";

    export default {
        name: "SaveCalculationDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog:      false,
                dataUpdated: false,
                contracts:   [],
                selectedContract: null,
                comment: "",
                name: "",
                patternsAmount: 3,
                amount: [],
                saveData:    false,
            }
        },

        mounted () {
            this.applyLocale();
            // this.loadContracts();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
             applyLocale () {
                this.amount = [
                    { text: this.$t("all"),     value: 0 },
                    { text: this.$t("first3"),  value: 3 },
                    { text: this.$t("first5"),  value: 5 },
                    { text: this.$t("first10"), value: 10 },
                ]
            },

            /**
             * Сброс параметров формы
             */
            resetForm () {
                this.loadContracts();
                this.name = "";
                this.comment = "";
                this.patternsAmount = 3;
                this.selectedContract = null;
            },

            /**
             * Обработчик нажатия кнопки отмены
             */
            cancelClick () {
                this.saveData = false;
                this.dialog   = false;
            },

            /**
             * Загрузка заказов
             */
             loadContracts () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}contracts/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {

                            this.contracts = response.data.contracts;

                            // this.contracts.forEach((contract) => {
                            //     contract.modDate = new Date(contract.updatedAt);
                            //     contract.modDate = `${contract.modDate.toLocaleDateString()} ${contract.modDate.toLocaleTimeString()}`
                            // })
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData"));
                        }
                    });
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                this.saveData = true;
                this.dialog   = false;
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
             showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },
        }
    }
</script>
